import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "delete",
  "use": "delete-usage",
  "viewBox": "0 0 15 19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 19\" id=\"delete\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.5 1v.5H14a.5.5 0 01.5.5v.5a.5.5 0 01-.5.5H1a.5.5 0 01-.5-.5V2a.5.5 0 01.5-.5h4.5V1a1 1 0 011-1h2a1 1 0 011 1zm-8 16.5V5h12v12.5A1.5 1.5 0 0112 19H3a1.5 1.5 0 01-1.5-1.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol